import React from 'react';
import {useIntl} from 'react-intl';
import ErrorPage from '../../common/ErrorPage/ErrorPage';
import PageTitle from '../PageTitle';
import {useIsDashboardLinkVisible} from './hooks/useIsDashboardLinkVisible';

export function NotFound() {
    const intl = useIntl();
    const isDashboardLinkVisible = useIsDashboardLinkVisible();

    const titleKey = 'esl.http.status_404';
    const messageKey = 'esl.http.status_404';

    const customTitleMessage = intl.formatMessage({id: titleKey, defaultMessage: 'Page Not Found'});
    const customErrorMessage = intl.formatMessage({id: messageKey, defaultMessage: 'The page you are looking for could not be found'});

    return (
        <>
            <PageTitle pageTitle={customTitleMessage} />
            <ErrorPage
                isDashboardLinkVisible={isDashboardLinkVisible}
                customTitleMessage={customTitleMessage}
                customErrorMessage={customErrorMessage}
            />
        </>
    );
}
